const Badge = {
  variants: {
    desarrollo: {
      display: "inline-block",
      padding: "5px 20px",
      borderRadius: "full",
      color: "#fff",
      bg: "rgba(0,0,0, 0.6)",
      fontSize: "12px",
      fontWeight: "400"
    }
  } 
}

export default Badge;